// extracted by mini-css-extract-plugin
export default {"container":"PortfolioHero_container__bf0UM","photo":"PortfolioHero_photo__+2uZw","info":"PortfolioHero_info__yzfD8"};